export default "__VITE_ASSET__BtXDffM6__"